import { SectionModel } from '@/types/sections.model';

export interface AppDataModel {
  name: string;
  description: string;
  logo: string;
  language: string;
  sections: SectionModel[];
  socials: {
    icon: string;
    link: string;
  }[];
  footer: {
    copyright: string;
    links: Array<{
      label: string;
      link: string;
    }>;
  };
}

export const sections: SectionModel[] = [
  {
    type: 'hero',
    id: 'hero-section',
    content: {
      title: 'FANOLA\'S BEST BLONDE',
      subtitle: 'Il biondo che desideri è possibile con le routine Fanola!',
      image: '/assets/image/hero.png',
      imageMobile: '/assets/image/hero_mobile.png',
    }
  },
  
  {
    type: 'products-carousel',
    id: 'products-carousel-1',
    content: {
      title: 'Scegli il look che vuoi ottenere!',
      subtitle: 'Ti guideremo verso i prodotti perfetti per realizzarlo e prenderti cura del tuo biondo, ogni giorno.',
    },
    items: [
      {
        id: '1',
        image: '/assets/image/biondo_freddo.png',
        title: 'Biondo Freddo',
        contents: [
          {
            id: 'item-1_content-1',
            image: '/assets/image/capelli_molto_dorati.jpg',
            title: 'Hai i capelli molto dorati?',
            highlights: [
              'Inizia con lo Shampoo Wonder No Yellow: usalo a ogni lavaggio e lascialo agire per 3/4 minuti per eliminare i riflessi gialli.',
              'Poi applica la Maschera Wonder No Yellow per 3 minuti: nutre i capelli e intensifica l’effetto anti-giallo.',
              'Prima della piega, proteggi tutto con Heat Block - il tuo scudo contro il calore di phon e piastra.'
            ],
            products: [
              {
                image: '/assets/image/products/No_Yellow_Shampoo_350ml.png',
                id: 'item-1_content-1_product-2',
                title: 'No Yellow Shampoo - 350ml',
              },
              {
                image: '/assets/image/products/No_Yellow_Mask_350ml.png',
                id: 'item-1_content-1_product-4',
                title: 'No Yellow Mask - 350ml',
              },
              {
                image: '/assets/image/products/Fantouch_Heat_Block_300ml.png',
                id: 'item-1_content-1_product-5',
                title: 'Fantouch Heat Block - 300ml',
              },
            ]
          },
          {
            id: 'item-1_content-2',
            image: '/assets/image/capelli_leggermente_dorati.jpg',
            title: 'Hai i capelli leggermente dorati?',
            highlights: [
              'Diversifica la tua routine alternando lo Shampoo Wonder No Yellow lasciandolo in posa per 2 minuti allo Shampoo Color Locker, per proteggere il colore e prolungarne la durata.',
              'Ad ogni lavaggio, non dimenticare di applicare la Maschera Wonder No Yellow lasciandola in posa per 3 minuti,  per massimizzare l\'effetto anti-giallo.',
              'Vuoi un tocco in più di luce? Spruzza il Glossing Spray Wonder Nourishing e preparati a brillare!'
            ],
            products: [
              {
                image: '/assets/image/products/No_Yellow_Shampoo_350ml.png',
                id: 'item-1_content-2_product-1',
                title: 'No Yellow Shampoo - 350ml',
              },
              {
                image: '/assets/image/products/No_Yellow_Mask_350ml.png',
                id: 'item-1_content-2_product-2',
                title: 'No Yellow Mask - 350ml',
              },
              {
                image: '/assets/image/products/Color_Locker_Shampoo_350ml.png',
                id: 'item-1_content-2_product-6',
                title: 'Color Locker Shampoo - 350ml',
              },
              {
                image: '/assets/image/products/Nourishing_Glossing_Spray_150ml.png',
                id: 'item-1_content-2_product-7',
                title: 'Nourishing Glossing Spray - 150ml',
              },
            ]
          },
        ]
      },
      {
        id: '2',
        image: '/assets/image/biondo_neutro.png',
        title: 'Biondo Neutro',
        contents: [
          {
            id: 'item-2_content-1',
            image: '/assets/image/capelli_molto_dorati.jpg',
            title: 'Hai i capelli molto dorati?',
            highlights: [
              'Alterna un lavaggio con Shampoo Wonder No Yellow con un tempo di posa di 2/3 minuti a un lavaggio con lo Shampoo Color Locker.',
              'E ricordati di applicare la maschera Wonder No Yellow a ogni lavaggio per intensificare l\'effetto anti-giallo.',
              'E se vuoi ottenere uno styling che duri più a lungo e capelli protetti dal calore, usa Thermo Fix prima della piega.'
            ],
            products: [
              {
                image: '/assets/image/products/No_Yellow_Shampoo_350ml.png',
                id: 'item-2_content-1_product-1',
                title: 'No Yellow Shampoo - 350ml',
              },
              {
                image: '/assets/image/products/Color_Locker_Shampoo_350ml.png',
                id: 'item-2_content-1_product-2',
                title: 'Color Locker Shampoo - 350ml',
              },
              {
                image: '/assets/image/products/No_Yellow_Mask_350ml.png',
                id: 'item-2_content-1_product-3',
                title: 'No Yellow Mask - 350ml',
              },
              
              {
                image: '/assets/image/products/Fantouch_Thermo_Fix_300ml.png',
                id: 'item-2_content-1_product-4',
                title: 'Fantouch Thermo Fix - 300ml',
              },
            ]
          },
          {
            id: 'item-2_content-2',
            image: '/assets/image/capelli_leggermente_dorati.jpg',
            title: 'Hai i capelli leggermente dorati?',
            highlights: [
              'Utilizza lo shampoo Wonder No Orange a ogni lavaggio abbinandolo alla maschera Wonder No Orange per un effetto delicato.',
              'Vuoi eliminare l\'effetto crespo? Ricordati di applicare prima dell\'asciugatura Wonder Smooth Serum.'
            ],
            products: [
              {
                image: '/assets/image/products/No_Orange_Shampoo_350ml.png',
                id: 'item-2_content-2_product-2',
                title: 'No Orange Shampoo - 350ml',
                url: '#'
              },
              {
                image: '/assets/image/products/No_Orange_Mask_350ml.png',
                id: 'item-2_content-2_product-4',
                title: 'No Orange Mask - 350ml',
                url: '#'
              },
              {
                image: '/assets/image/products/Fanola_Smooth Extra_serum 100_IMG.png',
                id: 'item-2_content-2_product-5',
                title: 'Fanola Smooth Extra Serum - 100ml',
                url: '#'
              },
            ]
          },
        ]
      },
      {
        id: '3',
        image: '/assets/image/biondo_irise.png',
        title: 'Biondo Irisé',
        contents: [
          {
            id: 'item-3_content-1',
            image: '/assets/image/capelli_molto_dorati.jpg',
            title: 'Hai i capelli molto dorati?',
            highlights: [
              'Inizia con lo Shampoo Wonder No Yellow e al primo lavaggio lascialo in posa per 10 minuti, nei lavaggi successivi lascialo agire per 5.',
              'Poi applica la Maschera Wonder No Yellow per 3 minuti: nutre i capelli e intensifica l\'effetto irisé.',
              'Effetto moridezza estrema? Applica Wonder Nourishing Leave-in Milk prima dell\'asciugatura.',
              'Infine, per dare massima lucentezza applica sui capelli asciutti Fan Touch Keep Me Bright.'
            ],
            products: [
              {
                image: '/assets/image/products/No_Yellow_Shampoo_350ml.png',
                id: 'item-3_content-1_product-1',
                title: 'No Yellow Shampoo - 350ml',
              },
              {
                image: '/assets/image/products/No_Yellow_Mask_350ml.png',
                id: 'item-3_content-1_product-2',
                title: 'No Yellow Mask - 350ml',
              },
              {
                image: '/assets/image/products/Nourishing_Leave_in_Milk_195ml.png',
                id: 'item-3_content-1_product-3',
                title: 'Nourishing Leave in Milk - 195ml',
              },
              {
                image: '/assets/image/products/Fantouch_Keep_Me_Bright_100ml.png',
                id: 'item-3_content-1_product-4',
                title: 'Fantouch Keep Me Bright - 100ml',
              },
            ]
          },
          {
            id: 'item-3_content-2',
            image: '/assets/image/capelli_leggermente_dorati.jpg',
            title: 'Hai i capelli leggermente dorati?',
            highlights: [
              'A ogni lavaggio usa lo shampoo Wonder No Yellow e lascialo agire per 4/5 minuti per creare e mantenere l\'effetto irisé.',
              'Poi applica la Maschera Wonder No Yellow per 5 minuti per nutrire i capelli e intensificare i riflessi irisé.',
              'Per un effetto long lasting del colore, vaporizza Wonder Milk Spray della linea Color Locker prima dell\'asciugatura.',
              'Extra shine? Applica qualche goccia di Wonder Elixir della linea Wonder Nourishing a capelli asciutti.'
            ],
            products: [
              {
                image: '/assets/image/products/No_Yellow_Shampoo_350ml.png',
                id: 'item-3_content-2_product-2',
                title: 'No Yellow Shampoo - 350ml',
                url: '#'
              },
              {
                image: '/assets/image/products/No_Yellow_Mask_350ml.png',
                id: 'item-3_content-2_product-4',
                title: 'No Yellow Mask - 350ml',
                url: '#'
              },
              {
                image: '/assets/image/products/Color_Locker_Milk_Spray_200ml.png',
                id: 'item-3_content-2_product-5',
                title: 'Color Locker Milk Spray - 200ml',
                url: '#'
              },
              {
                image: '/assets/image/products/Nourishing-ELIXIR100ml.png',
                id: 'item-3_content-2_product-6',
                title: 'Wonder Elixir - 100ml',
                url: '#'
              },
            ]
          },
        ]
      },
    ]
  },

  {
    type: 'highlight',
    id: 'highlight-1',
    content: {
      title: 'Wonder No Yellow',
      subtitle: 'L’alleato di bellezza che aiuta a contrastare l’effetto giallo, riportando i capelli biondi al loro splendore originario e conferendo brillantezza, morbidezza e vitalità.'
    },
    item: {
      type: 'video',
      source: '/assets/video/NO_YELLOW.mp4',
      title: 'Wonder No Yellow',
      autoplay: true,
      loop: true,
      muted: true,
      controls: false,
      aspectRatio: '9/16',
    }
  },
];

export const appData: AppDataModel = {
  name: "Fanola",
  description: "Svela tutte le possibilità.",
  logo: "/logo-fanola.svg",
  language: "it",
  sections,
  socials: [
    { icon: 'facebook', link: 'https://www.facebook.com/fanola.official?locale=it_IT' },
    { icon: 'instagram', link: 'https://www.instagram.com/fanola.official/' },
    { icon: 'tiktok', link: 'https://www.tiktok.com/@fanola.official?' },
  ],
  footer: {
    copyright: "© 2025 Fanola — All Rights Reserved",
    links: [
      { label: 'Privacy Policy', link: 'https://www.fanola.it/fa_it/privacy-policy' },
      { label: 'Terms of Service', link: 'https://www.fanola.it/fa_it/fanola-termini-condizioni' },
      { label: 'Cookies Settings', link: 'https://www.fanola.it/fa_it/cookie-policy' }
    ]
  }
};

export default appData;